<save-cms-resource
  [isComponent]="true"
  [isModal]="true"
  (saved)="saved.emit()"
  [baseReference]="baseReference()"
  [applicationCode]="applicationCode()"
  [resourceSuffix]="blocks()" />
